import userUtils from 'shared/src/user'
export const ROLE_LEVELS = userUtils.ROLE_LEVELS

// refresh the token every 1 minute
export const REFRESH_TOKEN_DELAY = 1000 * 60
export const API = '/api/v1'

export const RESPONSIVE_BREAKPOINT = 'md'

// how tall is the toolbar
export const TOOLBAR_OFFSET = 100

// how tall is the alert
export const ALERT_OFFSET = 75

export const BOOKINGS_FINISHED_MESSAGE = 'Bookings for today\'s slots are now closed on this calendar.'
export const BOOKINGS_FULL_MESSAGE = 'Today is fully booked on this calendar.'

// when scrolling the options / info pages
// how much do we allow the slot summary to
// bleed up before we start scrolling it downwards
// this is the same amount of space as the stepper
// takes up
export const FLOATING_SIDEBAR_OFFSET = 60
export const FLOATING_SIDEBAR_WIDTH = 400

export const APP_TITLE = 'Booking System'
export const BOOKING_BASE_PATH = 'book'
export const ROUTE_LOGGED_IN = 'admin.bookingforms.list'
export const ROUTE_LOGGED_OUT = 'admin.login'

export const ADMIN_USER_MENU = (user, userRole) => {
  const isProjectAdmin = ROLE_LEVELS[userRole] >= ROLE_LEVELS.admin
  const isSystemAdmin = userUtils.isAdmin(user)

  let base = [{
    title: 'Booking Forms',
    link: 'admin.bookingforms.list',
  }]

  if(isProjectAdmin) {
    base = base.concat([
      {
        title: 'Users',
        link: 'admin.users',
      }, 
      {
        title: 'Settings',
        link: 'admin.settings',
      },{
        title: 'Payment',
        link: 'admin.payment',
      }
    ])
  }
  
  if(isSystemAdmin) {
    base = base.concat([{
      title: 'Projects',
      link: 'admin.projects',
    }, {
      title: 'Update Configs',
      link: 'admin.updateConfigs',
    }])
  }

  base = base.concat([
    '-',
    {
      title: 'Logout',
      link: 'admin.logout',
    },
  ])

  return base
}

export const ADMIN_GUEST_MENU = () => [{
  title: 'Login',
  link: 'admin.login',
}]

export const PUBLIC_MENU = () => [{
  title: 'Home',
  link: 'home',
},
{
  title: 'Admin Panel',
  link: 'admin.login',
}]

export const PUBLIC_MENU_LOGGED_IN = (isAdmin) => PUBLIC_MENU().concat([{
  title: 'Logout',
  link: 'admin.logout',
}])

export const BOOKING_STEPS = [
  {
    id: 'calendar',
    title: 'Date',
    params: {
      date: 'today',
    },
  },
  {
    id: 'customize',
    title: 'Customize',
  },
  {
    id: 'details',
    title: 'Details',
  },
  {
    id: 'payment',
    title: 'Payment',
  }
]

const ALL_ADMIN_TABS = [
  {
    id: 'calendar',
    title: 'Calendar',
    role: 'admin',
    params: {
      date: 'today',
    },
  },
  {
    id: 'schedule',
    title: 'Schedule',
    role: 'schedule',
    params: {
      date: 'today',
    },
  },
  {
    id: 'config',
    title: 'Config',
    role: 'admin',
  },
  {
    id: 'communication',
    title: 'Communication',
    role: 'admin',
  },
  {
    id: 'welcomepage',
    title: 'Welcome Page',
    role: 'admin',
  },
  {
    id: 'embed',
    title: 'Embed',
    role: 'admin',
  },
]

export const ADMIN_TABS = (user, userRole) => {
  const isSystemAdmin = userUtils.isAdmin(user)
  return ALL_ADMIN_TABS.filter(tab => {
    if(isSystemAdmin) return true
    return ROLE_LEVELS[userRole] >= ROLE_LEVELS[tab.role]
  })
}